import React, { useState, useCallback } from 'react';
import { SlideInPanel } from './components/SlideInPanel.js';
import { CartPage, initCart, ShoppingCart } from '@sfly/cart-shared-library';
import '@sfly/cart-shared-library/style.css';
import './index.css';
import type { CartSlideInConfig } from './types.js';
import { fetchUserInfo, getEnvConfig } from './utils/commonUtil.js';

interface AppProps {
  config: CartSlideInConfig;
}

const envConfig = getEnvConfig();

export const App: React.FC<AppProps> = ({ config }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [userInfo, setUserInfo] = useState<any>({ loaded: false, data: null });

  const handleClose = useCallback(() => {
    setIsOpen(false);
    config.onClose?.();
  }, [config]);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  //remove the popup when navigating to checkout, if onCheckout callback is provided by host app
  const onCheckoutClick = config.onCheckout
    ? () => {
        config.onCheckout?.();
        window.cartSlideInMFE.destroy();
      }
    : undefined;

  // Expose open method on the container element so host app can re-open
  React.useEffect(() => {
    const container = document.getElementById(config.containerId);
    if (container) {
      (container as HTMLElement & { openCart: () => void }).openCart = open;
    }
  }, [config.containerId, open]);

  React.useEffect(() => {
    const loadUserInfo = async () => {
      const userInfo = await fetchUserInfo();
      setUserInfo({
        loaded: true,
        data: userInfo,
      });
    };
    loadUserInfo();
  }, []);

  return userInfo.loaded ? (
    config.layoutMode !== 'default' ? (
      <SlideInPanel isOpen={isOpen} onClose={handleClose}>
        <ShoppingCart
          userInfo={{
            ...userInfo.data,
            xApiKey: envConfig.cartApiKey,
          }}
          layoutMode="popup"
        >
          <CartPage
            onUpdateCart={config.onCartUpdated}
            onCheckout={onCheckoutClick}
          />
        </ShoppingCart>
      </SlideInPanel>
    ) : (
      <ShoppingCart
        userInfo={{
          ...userInfo.data,
          xApiKey: envConfig.cartApiKey,
        }}
        layoutMode="default"
      >
        <CartPage
          onUpdateCart={config.onCartUpdated}
          onCheckout={config.onCheckout}
        />
      </ShoppingCart>
    )
  ) : null;
};
